import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("delphi_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // CEO "View as" : when impersonating, add the target member's id header.
  // The backend accepts this ONLY if the caller is CEO.
  const impersonateId = localStorage.getItem("delphi_impersonate_id");
  if (impersonateId) {
    config.headers["X-Impersonate-User-Id"] = impersonateId;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("delphi_token");
      localStorage.removeItem("delphi_user");
      localStorage.removeItem("delphi_impersonate_id");
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
